import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { RectangleSpinner } from "../../../../common/spinners";

import * as withdrawalEmailTemplateActions from "./withdrawalEmailTemplateActions";

class BasicWithdrawalEmailTemplate extends React.Component {
  componentWillMount() {
    const { clientId, isInactiveReasonType, emailMessage } =
      this.props.initialValues || this.props;
    this.props.withdrawalEmailTemplateActions.getTemplate(
      "/v1/withdrawals/template",
      { clientId, isInactiveReasonType, emailMessage },
      {}
    );
  }

  componentWillUnmount() {
    this.props.withdrawalEmailTemplateActions.clearTemplate();
  }

  render() {
    return (
      <div>
        {(!this.props.template && <RectangleSpinner />) || (
          <div dangerouslySetInnerHTML={{ __html: this.props.template }} />
        )}
      </div>
    );
  }
}

BasicWithdrawalEmailTemplate.propTypes = {
  clientId: PropTypes.number,
  initialValues: PropTypes.object,
  isInactiveReasonType: PropTypes.string,
  template: PropTypes.string,
  withdrawalEmailTemplateActions: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    template: state.withdrawalEmailTemplate.template || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    withdrawalEmailTemplateActions: bindActionCreators(
      withdrawalEmailTemplateActions,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {withRef: true}
)(BasicWithdrawalEmailTemplate);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/withdrawal-configuration/BasicWithdrawalEmailTemplate.js